import type { ServerEnvConfigType } from '@/shared/config/ServerEnvConfigType';
import type { DocsSiteVisitType } from '@/shared/constant/DocsIdTypeData';
import { OnlineType } from '@/shared/constant/OnlineType';
import type { LocaleType } from '@/shared/i18n/i18n';
import { clientRequest } from '@/shared/request/clientRequest.client';

export type RequestDocsSiteCloneDataType = {
  id: string | number;
  teamId: string;
  userId: string;
  branchId?: number | undefined;
  projectId?: string | number;
};

export async function requestDocsSiteClone(
  requestData: RequestDocsSiteCloneDataType,
  onlineType: OnlineType,
  envConfig: ServerEnvConfigType,
  clientI18n: (key: keyof LocaleType, params?: Record<string, string>) => string,
  visitType?: DocsSiteVisitType,
  subdirectory?: string,
) {
  const url = (() => {
    if (onlineType === OnlineType.SharedDoc) {
      return `/api/v1/projects/${requestData.projectId}/shared-docs/${requestData.id}/clone`;
    }

    return `/api/v1/projects/${requestData.id}/published-projects/clone`;
  })();

  return await clientRequest<{ teamName: string; projectId: number }>(
    url,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
      projectId: Number(requestData.projectId || 0),
      body: JSON.stringify(requestData),
      envConfig,
      visitType,
      subdirectory,
    },
    clientI18n,
  );
}
